import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Heading, Paragraph } from '@digdir/designsystemet-react';
import { useUsesSafetyReps } from '../../../hooks/queries/hms/useHmsSettingsQuery';
import { safetyRepText } from '../../HRDashboard/safetyRepText';
import { dayAndMonth } from '../surveyProcessView';
import classes from '../WorkEnvironmentSurveyProcess.module.css';

type Props = {
  responseDeadline: string | null;
  /** How many have answered so far, once it is known */
  responses: number | null;
};

/**
 * While the team answers, the next step is always the risk calculation: the risk to assess appears here, and when.
 * Shown to everyone who sees the survey, also those «Kom i gang» sends here to assess it.
 */
export const NextStepCard = ({ responseDeadline, responses }: Props): ReactElement => {
  const { t, i18n } = useTranslation();
  const text = safetyRepText(useUsesSafetyReps());
  const K = 'workEnvironmentProcess.notReady';
  return (
    <section aria-labelledby="next-heading" className={`${classes.card} ${classes.sideCard}`} data-gap="sm">
      <span className={`ds-label ${classes.eyebrow}`} data-size="sm">
        {t('workEnvironmentProcess.next.label')}
      </span>
      <Heading level={2} data-size="xs" id="next-heading">
        {t(`${K}.title`)}
      </Heading>
      <Paragraph data-size="sm" className={classes.subtle}>
        {[
          responseDeadline
            ? t(`${K}.when`, { date: dayAndMonth(responseDeadline, i18n.language) })
            : t(`${K}.whenWithoutDeadline`),
          responses !== null && t(`${K}.answered`, { answered: responses }),
          t(text(`${K}.assess`)),
        ]
          .filter(Boolean)
          .join(' ')}
      </Paragraph>
    </section>
  );
};
